import React from "react";
import "../styles/Contact.scss";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h2>Ready to build the future?</h2>
        <ul>
          <li><a href="mailto:mattbalter@gmail.com" className="social-link">EMAIL</a></li>
          <li><a href="https://www.linkedin.com/in/mattalter/" target="_blank" rel="noopener noreferrer" className="social-link">LINKEDIN</a></li>
        </ul>
      </div>
    </section>
  );
};

export default Contact;
